<template>
  <router-view />
</template>

<style lang="css">
.container.page {
  max-width: 1185px;
}
</style>

<script>

export default {
  name: 'App',
  data: () => ({
    //
  }),
};
</script>
